<script>
  // Extensions
  import View from '@/views/View'
  // Mixins
  import LoadSections from '@/mixins/load-sections'
  export default {
    name: 'Order',
    metaInfo: { title: 'Order' },
    extends: View,
    mixins: [
      LoadSections([
        'order-search',
      ]),
    ],
    props: {
      id: {
        type: String,
        default: 'order',
      },
    },
  }
</script>
